export default function Machines_A_11 (number = 1) {
  return {
    name: '人造恒星',
    icon: '/static/img/machines/a11.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_A/Machines_A_11.js